import { render, staticRenderFns } from "./Angebotliste.vue?vue&type=template&id=5f2c0eaf"
import script from "./Angebotliste.vue?vue&type=script&lang=js"
export * from "./Angebotliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports